import React from "react";
import "./Gallery.css";
import Project from "./Project";

import GEHQ1 from "./GEHQ1.jpg";
import GEHQ2 from "./GEHQ2.jpg";
import GEHQ3 from "./GEHQ3.jpg";
import GEHQ4 from "./GEHQ4.jpg";
import GEHQ5 from "./GEHQ5.jpg";
import GEHQ6 from "./GEHQ6.jpg";
import GEHQ7 from "./GEHQ7.jpg";
import DPK1 from "./DPK1.png";
import DPK2 from "./DPK2.jpg";
import DPK3 from "./DPK3.png";
import DPK4 from "./DPK4.png";
import DPK5 from "./DPK5.jpg";
import EIBFS1 from "./EIBFS1.jpg";
import EIBFS2 from "./EIBFS2.jpg";
import EIBFS3 from "./EIBFS3.jpg";
import EIBFS4 from "./EIBFS4.jpg";
import EIBFS5 from "./EIBFS5.jpg";
import EIBFS6 from "./EIBFS6.jpg";
import MH1 from "./MH1.jpg";
import MH2 from "./MH2.jpg";
import MH3 from "./MH3.jpg";
import MH4 from "./MH4.jpg";
import ML1 from "./ML1.jpg";
import ML2 from "./ML2.jpg";
import ML3 from "./ML3.jpg";
import ML4 from "./ML4.jpg";
import ML5 from "./ML5.jpg";
import OSV1 from "./OSV1.png";
import OSV2 from "./OSV2.png";
import OSV3 from "./OSV3.png";
import OSV4 from "./OSV4.png";
import OSV5 from "./OSV5.png";
import OSV6 from "./OSV6.png";

function Gallery() {
    const projects = [
        {
            title: "GE HQ",
            Dissection: "2B+G+4",
            location: "DIC, Dubai, United Arab Emirates",
            Client: "Dubai Properties",
            Consultant: "DAR Consultant",
            images: [GEHQ1, GEHQ2, GEHQ3, GEHQ4, GEHQ5, GEHQ6, GEHQ7]
        },
        {
            title: "Dubai Knowledge Park",
            Dissection: "Phase II",
            location: "Dubai, United Arab Emirates",
            Client: "Dubai Properties",
            Consultant: "DAR Consultant",
            images: [DPK1, DPK2, DPK3, DPK4, DPK5]
        },
        {
            title: "EIBFS",
            Dissection: "G+1",
            location: "Academic City",
            Client: "EIBFS",
            Consultant: "DAR Consultant",
            images: [EIBFS1, EIBFS2, EIBFS3, EIBFS4, EIBFS5, EIBFS6]
        },
        {
            title: "Mirdif Hospital",
            Dissection: "G+3",
            location: "Mirdif, Dubai, United Arab Emirates",
            Client: "HMS Group",
            Consultant: "Rqitects Design Studio",
            images: [MH1, MH2, MH3, MH4]
        },
        {
            title: "Osama Salman Villa",
            Dissection: "G+1",
            location: "Al-Khawaneej, Dubai, United Arab Emirates",
            Client: "Mr.Osama Salman",
            Consultant: "GreenSpace Interiors",
            images: [OSV5, OSV1, OSV2, OSV3, OSV4, OSV6]
        },
        {
            title: "Millennium Hotel",
            Dissection: "Hotel",
            location: "Mirdif, Dubai, United Arab Emirates",
            Client: "DIRC",
            Consultant: "DIRC",
            images: [ML1, ML2, ML3, ML4, ML5]
        }
    ];

    return (
        <section id="gallery" className="gallery">
            <div className="gallery__container">
                <div className="section-heading">
                    <span className="section-heading__label">Our Work</span>
                    <h2 className="section-heading__title">Project Gallery</h2>
                    <span className="section-heading__bar"></span>
                </div>

                <div className="gallery__list">
                    {projects.map((project, index) => (
                        <Project
                            key={index}
                            project={project}
                            isLeftAligned={index % 2 === 0}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Gallery;
